import { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { useNavigate, useParams } from "react-router-dom";
import { boardActions } from "../../../actions/boards";
import ArrowLeftWithBody from "../../../assets/icons/ArrowLeftWithBody";
import editGray from "../../../assets/svg/edit-gray.svg";
import eyeGray from "../../../assets/svg/eye-gray.svg";
import plusGray from "../../../assets/svg/plus-gray.svg";
import qrWhite from "../../../assets/svg/qr-white.svg";
import tickWhite from "../../../assets/svg/tick-white.svg";
import trashRed from "../../../assets/svg/trash-red.svg";
import Modal from "../../../components/Modal/Modal";
import { useBoard, useBoards, useBoardTasks } from "../../../hooks/board";
import { boardBgColors, boardColumns } from "../../../misc/constants";
import { useGlobalUserState } from "../../../stores/user";
import { BoardColumn } from "./BoardColumn";
import { simpleGetter } from "../../../actions/common";
import { userApi } from "../../../api/api";
import { showSnackbar } from "../../../misc/utils";
import InputField from "../../../components/input-field/InputField";
import AdminSelector from "../../../components/Boards/AdminSelector/AdminSelector";
import DefaultButton from "../../../components/default-button/DefaultButton";
import Tick from "../../../assets/icons/Tick";

export const Board = ({}) => {
    const navigate = useNavigate();
    const userState = useGlobalUserState();
    const { id } = useParams();
    const [selectedId, setSelectedId] = useState(parseInt(id));
    const [triggerFetch, setTriggerFetch] = useState(0);
    const [modalMode, setModalMode] = useState("add");
    const userObj = userState.get();
    const user = userObj.user || {};
    const [modalOpen, setModalOpen] = useState(false);
    const [qrModalOpen, setQrModalOpen] = useState(false);
    const [boardBg, setBoardBg] = useState("");
    const [boardName, setBoardName] = useState("");
    const boards = useBoards(triggerFetch);
    const board = useBoard(selectedId);
    const boardTasks = useBoardTasks(selectedId, triggerFetch);
    const [visible, setVisible] = useState("");
    const [admins, setAdmins] = useState([]);

    useEffect(() => {
        if (modalOpen) {
            setBoardName(board.name);
            setBoardBg(board.bg);
        }
    }, [modalOpen]);

    const updateTriggerFetch = () => {
        setTriggerFetch(triggerFetch + 1);
    };

    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };

    const toggleQrModal = () => {
        setQrModalOpen(!qrModalOpen);
    };

    const openBoardModal = (mode) => () => {
        setModalMode(mode);
        toggleModal();
    };

    const onSumbit = async () => {
        const result = await boardActions.createBoard(boardName, boardBg, board.id);
        if (result.success) {
            updateTriggerFetch();
            toggleModal();
        }
    };

    const deleteBoard = async () => {
        const result = await simpleGetter(userApi.deleteBoard, board.id);
        if (result.success) {
            showSnackbar("Успешно", "success");
            navigate("/admin/boards");
        }
    };

    const selectedBoard = boards.find((b) => b.id === selectedId);
    if (!Boolean(selectedBoard)) {
        return null;
    }

    const isFormValid =
        boardBg.trim() !== "" &&
        boardName.trim() !== "" &&
        visible.trim() !== "" &&
        admins.length > 0;

    const createBoard = async () => {
        const result = await boardActions.createBoard(boardName, boardBg);
        if (result.success) {
            showSnackbar("Доска успешно создана!", "success");
            setModalOpen(false);
            updateTriggerFetch();
            setTimeout(() => {
                navigate(`/admin/boards/${result.id}`);
            }, 300);
        } else {
            showSnackbar("Ошибка при создании доски", "error");
        }
    };


    return (
        <div className="flex flex-col w-full min-h-screen bg-[#f8f9fd] p-4 md:p-8">
            <div className="flex flex-row gap-3 overflow-x-auto pb-2 -mx-4 px-4 md:mx-0 md:px-0 snap-x snap-mandatory">
                {boards.map((b) => (
                    <div
                        className={`flex flex-row cursor-pointer items-center p-3 pr-4 md:pr-5 flex-shrink-0 snap-start ${
                            b.bg
                        } rounded-xl ${
                            selectedId === b.id ? "border-2 border-[#0068FF]" : "border border-transparent"
                        }`}
                        onClick={() => setSelectedId(b.id)}
                        title={b.name}
                        aria-label={`Выбрать доску ${b.name}`}
                    >
            <span className="text-sm font-medium text-[#1A1A1A] max-w-[180px] md:max-w-none truncate">
              {b.name && b.name.length > 9 ? `${b.name.substring(0, 9)}...` : b.name}
            </span>
                    </div>
                ))}
                <button
                    className="border border-[#AFB7CA] rounded-xl p-[12px] md:p-[15px] flex flex-row justify-center items-center cursor-pointer flex-shrink-0 snap-start"
                    onClick={openBoardModal("add")}
                    aria-label="Создать новую доску"
                    title="Создать доску"
                >
                    <img src={plusGray} />
                </button>
            </div>
            <div
                className={`flex flex-col md:flex-row mt-4 items-start md:items-center rounded-xl px-4 py-[20px] md:py-[30px] ${selectedBoard.bg}`}
            >
                <div className="flex flex-col w-full md:flex-[9]">
          <span className="font-semibold text-xl md:text-2xl text-[#1A1A1A]">
            {selectedBoard.name}
          </span>
                    <div className="flex flex-row mt-1.5 items-center">
                        <img src={eyeGray} />
                        <span className="ml-1 font-medium text-[12px] md:text-[13px] text-[#5F6B88]">
              Рабочее пространство
            </span>
                    </div>
                </div>
                <div className="flex flex-row flex-wrap gap-2 md:gap-3 justify-start md:justify-end w-full md:flex-[11] mt-3 md:mt-0">
                    <button
                        className="bg-[#1A1A1A] py-2 px-3 rounded-lg flex flex-row items-center"
                        onClick={toggleQrModal}
                        aria-label="Показать QR-код"
                        title="QR-код"
                    >
                        <img src={qrWhite} />
                        <span className="hidden md:inline ml-2 text-[15px] font-semibold text-white text-nowrap ">
              QR-код
            </span>
                    </button>
                    <button
                        className="border border-[#5F6B88] py-2 px-3 rounded-lg flex flex-row items-center"
                        onClick={openBoardModal("edit")}
                        aria-label="Редактировать доску"
                        title="Редактировать"
                    >
                        <img src={editGray} />
                        <span className="hidden md:inline ml-2 text-[15px] font-semibold text-[#5F6B88]">
              Редактировать
            </span>
                    </button>
                    <button
                        className="border border-[#F12D2D] py-2 px-3 rounded-lg flex flex-row items-center"
                        onClick={deleteBoard}
                        aria-label="Удалить доску"
                        title="Удалить"
                    >
                        <img src={trashRed} />
                        <span className="hidden md:inline ml-2 text-[15px] font-semibold text-[#F12D2D]">
              Удалить
            </span>
                    </button>
                </div>
            </div>
            <div className="flex flex-row mt-4 overflow-x-auto -mx-2 px-2 gap-2 snap-x snap-mandatory">
                {boardColumns.map((c) => (
                    <div className="flex-1 px-2 min-w-[300px] md:min-w-0 snap-start">
                        <BoardColumn
                            board={selectedBoard}
                            tasks={boardTasks}
                            type={c.label}
                            setTrigger={setTriggerFetch}
                        />
                    </div>
                ))}
            </div>
            <Modal
                dimensions="w-2/5 h-2/5 rounded-[10px] p-7"
                visible={modalOpen}
                setVisible={setModalOpen}
                additionalClassName="!w-fit"
            >
                <div className="flex flex-col">
                    <div className="flex flex-row justify-center">
                        <p className="text-lg text-black font-semibold">Создать доску</p>
                    </div>
                    <p className="text-sm font-semibold text-black">Фон</p>
                    <div className="flex flex-row mt-1.5">
                        {boardBgColors.map((bg) => (
                            <div
                                className={`flex-1 h-[43px] ${bg} mr-5 rounded-md cursor-pointer ${
                                    boardBg === bg ? "border-2 border-valley-main" : ""
                                }`}
                                onClick={() => setBoardBg(bg)}
                            />
                        ))}
                    </div>
                    <div className="mt-6 flex flex-col gap-6">
                        <InputField
                            label="Название"
                            type="text"
                            additionalClassName="mt-1.5 border-none rounded-md !bg-[#F0F3FA] text-black py-3 px-2 !placeholder-[#AFB7CA]"
                            value={boardName}
                            handleChange={(e) => setBoardName(e.target.value)}
                            placeholder="Введите название доски"
                        />
                        <InputField
                            label="Видимость"
                            type="select"
                            additionalClassName="mt-1.5 border-none rounded-md !bg-[#F0F3FA] text-black py-3 px-2 !placeholder-[#AFB7CA]"
                            value={visible}
                            handleChange={(e) => setVisible(e.target.value)}
                            placeholder="Введите название доски"
                            options={[
                                { value: "public", label: "Общедоступна" },
                                { value: "private", label: "Приватная" },
                            ]}
                        />
                    </div>

                    <AdminSelector admins={admins} setAdmins={setAdmins} />
                    <div className="mt-8 flex gap-3 text-nowrap">
                        <DefaultButton
                            buttonText="Вернуться"
                            additionalStyle="bg-[#5F6B88] text-white px-12 py-3 gap-2"
                            Icon={ArrowLeftWithBody}
                            onClick={() => setModalOpen(false)}
                        />
                        <DefaultButton
                            buttonText="Создать доску"
                            additionalStyle={`px-12 py-3 gap-2 ${
                                isFormValid
                                    ? "bg-[#3BBC30] text-white"
                                    : "bg-[#3BBC30] text-white opacity-30 cursor-not-allowed"
                            }`}
                            Icon={Tick}
                            disabled={!isFormValid}
                            onClick={createBoard}
                        />
                    </div>
                </div>
            </Modal>
            <Modal
                dimensions="w-2/5 rounded-[10px] p-7"
                visible={qrModalOpen}
                setVisible={setQrModalOpen}
                additionalClassName="!w-[95vw] sm:!w-[80vw] md:!w-[55vw] lg:!w-[40vw] xl:!w-[30vw]"
            >
                <div className="flex flex-row justify-center">
                    <QRCode
                        value={JSON.stringify({
                            type: "Board",
                            boardId: selectedBoard.id,
                        })}
                    />
                </div>
            </Modal>
        </div>
    );
};